import { Button } from '@/components';
import { MasterTranslation } from '@/constants';
import { useGlobalState } from '@/hooks';
import { ButtonSize, ButtonVariant } from '@/interfaces';
import { Dialog } from '@/modules/pmt/components/Dialog';
import type { FC, ReactNode } from 'react';
import { ButtonGroup } from './ConfirmDialog.styles';

interface ConfirmDialogProps {
  showDialog: boolean;
  setShowDialog: (show: boolean) => void;
  onConfirm: () => void;
  mainText: string | ReactNode;
  subText?: string | ReactNode;
  cancelText?: string | ReactNode;
  confirmText: string | ReactNode;
}

export const ConfirmDialog: FC<ConfirmDialogProps> = ({
  showDialog,
  setShowDialog,
  onConfirm,
  mainText,
  subText,
  cancelText,
  confirmText,
}) => {
  const { t } = useGlobalState();

  return (
    <Dialog show={showDialog} onHide={() => setShowDialog(false)}>
      <Dialog.Header closeable onClose={() => setShowDialog(false)} />
      <Dialog.Content>
        <Dialog.MainText>{mainText}</Dialog.MainText>
        {subText && <Dialog.SubText>{subText}</Dialog.SubText>}
        <ButtonGroup>
          <Button
            isPMTButton
            truncate={2}
            size={ButtonSize.Large}
            variant={ButtonVariant.Outlined}
            onClick={() => setShowDialog(false)}
          >
            {cancelText || t(MasterTranslation.Cancel)}
          </Button>
          <Button isPMTButton truncate={2} size={ButtonSize.Large} onClick={onConfirm}>
            {confirmText}
          </Button>
        </ButtonGroup>
      </Dialog.Content>
    </Dialog>
  );
};
